import React from "react";
import "../App.css"; // Import the CSS file

const Header = () => {
    return (
        <header className="header">
            <h1 className="header-title">
                <a href="https://muslims.wtf/" rel="home">
                    Muslims.wtf
                </a>
            </h1>
        </header>
    );
};

export default Header;